import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RiRocket2Fill } from '@remixicon/react';

const gettingStartedPage = PageBlueprint.make({
  name: 'getting-started',
  params: {
    path: '/getting-started',
    title: 'Getting Started',
    icon: <RiRocket2Fill />,
    loader: () =>
      import('../components/getting-started-page/GettingStartedPage').then(
        m => <m.GettingStartedPage />,
      ),
  },
});

export default createFrontendPlugin({
  pluginId: 'getting-started',
  extensions: [gettingStartedPage],
});
